import { CoreIcon } from '../core-icon';
import couponSVG from '../../assets/icons/coupon.svg';
import type { IconProps } from '../core-icon';

export const CouponIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={couponSVG} {...props} />;
};
